<template>
  <div v-if="flashMessages" class="messages">
    <toaster-message v-for="(flashMessage, index) in flashMessages" :key="index" :flashMessage="flashMessage" />
  </div>
</template>

<script>
import moment from "moment"
import ToasterMessage from "@/components/toaster/ToasterMessage"
import { mapGetters } from "vuex"

export default {
  name: "ToasterMessages",
  props: [],
  components: {
    ToasterMessage
  },
  data() {
    return {
      moment: moment,
      transition: false
    };
  },
  computed: {
    ...mapGetters(["flashMessages"])
  },
  methods: {}

};
</script>

<style lang="scss" scoped>
.messages {
  position: absolute;
  right: 20px;
  top: 60px;
  z-index: 20;
}
</style>
